import { FontButton } from "../../../../molecules/buttons/FontButton";
import { FontSizeControlZustand } from "../FontSizeControlZustand";

export function FontButtonZustand() {
  return (
    <FontButton>
      <FontSizeControlZustand />
    </FontButton>
  );
}
